<template>
  <div class="pvai-game">
    <b-loading :is-full-page="false" v-model="isLoading"></b-loading>
  </div>
</template>

<script>
import { GAME_OVERRIDE } from "vue-chess-shared/constants";
import { MatchesAPI } from "@/services/api";
import { mapGetters } from "vuex";
import joinOrOpenMatchMixin from "@/mixins/joinOrOpenMatchMixin";
import { MATCH_DEFAULT, MATCH_DURATION } from "@/constants";
import { toAiProfile } from "vue-chess-shared/utils/ai-helper";
import _ from "lodash";

export default {
  name: "PvAiLevel",

  mixins: [joinOrOpenMatchMixin],

  data() {
    return {
      isLoading: true,
    };
  },

  watch: {
    incompleteMatches() {
      this.createMatchOfLevel();
    },
  },

  computed: {
    ...mapGetters({
      currentProfile: "getProfile",
    }),

    username() {
      return this.currentProfile ? this.currentProfile.username : null;
    },

    level() {
      const queryLevel = this.$route.query.level;
      return isNaN(queryLevel) ? 1 : Number(queryLevel);
    },

    isReady() {
      return this.level && this.username;
    },
  },

  methods: {
    createMatchOfLevel: _.debounce(function() {
      this.checkLevelAndCreateMatch();
    }, 1000),

    async checkLevelAndCreateMatch() {
      if (!this.isReady) {
        return;
      }

      this.stats = await MatchesAPI.getPlayerStats(this.username);

      if (this.level === 1 || this.level <= this.stats.rating) {
        const opponent = toAiProfile(null, this.level);

        this.joinOpenMatchOrOpenNewMatch(
          MATCH_DURATION.UNLIMITED,
          MATCH_DEFAULT.INCREMENT,
          MATCH_DEFAULT.VARIANT,
          GAME_OVERRIDE.PVAI,
          opponent
        );
      } else {
        // not a valid level, go back to home
        this.$router.push({
          name: "home",
        });
      }
    },
  },

  created() {
    if (!this.$route.query.level) {
      this.$router.replace({
        name: "home",
      });
    }
  },
};
</script>

<style scoped></style>
